import { render, staticRenderFns } from "./CompanyFormsPage.vue?vue&type=template&id=0b0453de&"
import script from "./CompanyFormsPage.vue?vue&type=script&lang=js&"
export * from "./CompanyFormsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports